/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const RenewalHistoryPage = lazyLoad(
  () => import('./index'),
  module => module.RenewalHistoryPage,
);
